import { Text } from '@chakra-ui/react';

import ChooseMonths from '../../../ChooseMonths/ChooseMonths';

import calculatePrice from '../../../../utils/calculators/calculatePrice';
import CustomChakraButton from '../../../CustomChakraButton/CustomChakraButton';

import KeyValueTable from './FinanceTable';
import StakesFinanceTable from './StakesFinanceTable';
import TenantPaymentsTable from './TenantPaymentsTable';
import { useTenantFinances } from './useTenantFinances';

export const SummaryFinances = () => {
  const {
    financeSummary,
    stakeStats,
    tenantPayments,
    dateForSummaryStats,
    setDateForSummaryStats,
    dateForMonthStakeStats,
    setDateForMonthStakeStats,
    onDownloadReport,
    onDownloadPaymentReport,
    todayDateLabel
  } = useTenantFinances();

  return (
    <section className="SalesSystem py-4 px-6 w-full overflow-x-hidden">
      <div className="relative mb-8">
        <div className="absolute bottom-[-16px] left-[-24px] w-screen h-[1px] bg-gray-200"></div>
        <div className="w-full flex flex-col sm:flex-row items-center justify-between">
          <div className="flex flex-col basis-5/12">
            <div>
              <Text
                whiteSpace="normal"
                overflow="hidden"
                textOverflow="ellipsis"
                className="font-semibold text-base normal-case text-grayLight-900">
                Finanse
              </Text>
              <Text
                whiteSpace="normal"
                overflow="hidden"
                textOverflow="ellipsis"
                className="font-normal text-sm normal-case text-grayLight-700">
                W tym miejscu możesz sprawdzić statystyki finansowe i pobrać raport statystyk
                ilościowych na wybrany miesiąc.
              </Text>
            </div>
          </div>
          <ChooseMonths
            setDate={setDateForSummaryStats}
            currentDate={dateForSummaryStats}
            mode="month"
          />
        </div>
      </div>
      <Text
        whiteSpace="normal"
        overflow="hidden"
        textOverflow="ellipsis"
        className="mb-6 font-semibold text-sm normal-case text-grayLight-900">
        Statystyki finansowe
      </Text>
      <div>
        <KeyValueTable
          isLoading={false}
          headers={{ label: 'Statystyki finansowe', value: 'Wartość' }}
          data={[
            {
              key: 'Wartość zamówień tPay zrealizowanych raportowanym miesiącu.',
              value: financeSummary?.tpayPayments
                ? calculatePrice(financeSummary?.tpayPayments, 'zł')
                : '0,00 zł'
            },
            {
              key: 'Wartość zamówień Gotówką zrealizowanych raportowanym miesiącu.',
              value: financeSummary?.cashPayments
                ? calculatePrice(financeSummary?.cashPayments, 'zł')
                : '0,00 zł'
            }
          ]}
        />
      </div>

      <div className="mt-spacing-3xl">
        <KeyValueTable
          isLoading={false}
          headers={{
            label: `Aktualna statystyka [${todayDateLabel}]`,
            value: 'Wartość'
          }}
          data={[
            {
              key: 'Suma dodatnich sald Konsumentów',
              value: financeSummary?.negativeSaldoSum
                ? calculatePrice(financeSummary?.negativeSaldoSum, 'zł')
                : '0,00 zł'
            },
            {
              key: 'Suma ujemnych sald Konsumentów',
              value: financeSummary?.negativeSaldoSum
                ? calculatePrice(financeSummary?.negativeSaldoSum, 'zł')
                : '0,00 zł'
            }
          ]}
        />
      </div>

      <div className="mt-spacing-3xl">
        <div className="w-full flex flex-col md:flex-row items-center justify-between mb-6">
          <div className="flex flex-col">
            <div>
              <Text
                whiteSpace="normal"
                overflow="hidden"
                textOverflow="ellipsis"
                className="font-semibold text-base normal-case text-grayLight-900">
                Statystyki ilościowe sprzedanych Stawek
              </Text>
            </div>
          </div>
          <div className="flex items-center flex-col sm:flex-row gap-6">
            <ChooseMonths
              setDate={setDateForMonthStakeStats}
              currentDate={dateForMonthStakeStats}
              mode="month"
            />
            <CustomChakraButton
              hierarchy="primary"
              size="md"
              iconPosition="right"
              dropdownOptions={[
                { label: 'PDF', action: () => onDownloadReport('PDF') },
                { label: 'Excel (.xls)', action: () => onDownloadReport('XLSX') }
              ]}
              buttonProps={{
                onClick: () => {
                  return null;
                }
              }}>
              Pobierz raport
            </CustomChakraButton>
          </div>
        </div>
        <StakesFinanceTable isLoading={false} data={stakeStats} />
      </div>
      <div className="mt-spacing-3xl">
        <div className="w-full flex flex-col md:flex-row items-center justify-between mb-6">
          <div className="flex flex-col">
            <div>
              <Text
                whiteSpace="normal"
                overflow="hidden"
                textOverflow="ellipsis"
                className="font-semibold text-base normal-case text-grayLight-900">
                Historia wpłat z jemszkole na konto bankowe oddziału
              </Text>
            </div>
          </div>
        </div>
        <TenantPaymentsTable
          isLoading={false}
          data={tenantPayments}
          onDownloadPaymentReport={onDownloadPaymentReport}
        />
      </div>
    </section>
  );
};
